import React, { ReactNode } from 'react';
import './EmptyState.scss';

interface EmptyStateProps {
    icon?: ReactNode;
    text?: string;
}

const EmptyStateComponent: React.FC<EmptyStateProps> = ({ icon, text }) => {
    return (
        <div className="EmptyState">
            {icon && <div className="EmptyState__icon mb-1.5">{icon}</div>}
            {text && <div className="EmptyState__description nereus-color-neutral-grey nereus-caption">{text}</div>}
        </div>
    );
};

export default EmptyStateComponent;
